<template>
  <ProblemListStep
    v-if="state.matches('reportProblemFlow.problemListStep')"
    :problemTypes
    :send
    :shouldShowSendMessageTitle
  />
  <DetailsStep
    v-if="state.matches('reportProblemFlow.detailsStep')"
    :mostUrgentTask
    :send
    :state
    @done="emit('done')"
    @exit="emit('exit')"
  />
</template>

<script setup lang="ts">
import type {
  OrderlineOpenTask,
  ProblemType,
} from '~/api/seller-after-sales/types'

import type { MachineSend, MachineState } from '../../ActionBar.machine.type'

import DetailsStep from './DetailsStep/DetailsStep.vue'
import ProblemListStep from './ProblemListStep/ProblemListStep.vue'

defineProps<{
  problemTypes: ProblemType[]
  send: MachineSend
  state: MachineState
  shouldShowSendMessageTitle?: boolean
  mostUrgentTask?: OrderlineOpenTask
}>()

const emit = defineEmits(['done', 'exit'])
</script>
